import type { ResourceFilterKey } from '@/common/api/types/itemFilters';

const OPEN_POSITION_PICKLIST_FILTERS = [
  'locationId',
  'roleId',
  'skillId',
] as const satisfies readonly ResourceFilterKey[];

export const OPEN_POSITION_FILTER_KEYS = [...OPEN_POSITION_PICKLIST_FILTERS] as const;
export type OpenPositionFilterKey = (typeof OPEN_POSITION_FILTER_KEYS)[number];
